import React from 'react'
import Link from 'gatsby-link'
import { Panel, Image, Col, Popover, Alert, Grid, Table } from 'react-bootstrap';
import headshot from "../images/holgernew.jpg"
import cloud from "../images/wordcloud.svg"

const IndexPage = () => 
		(
				<div>
				<Grid fluid>
				<Col xs={12}  sm={5} md={4} mdPush={8}>
				<Panel>
				<Panel.Heading>Me</Panel.Heading>
				<Panel.Body>
 				<Image src={headshot} responsive rounded/>
				<Alert bsStyle="danger">
				I am currently looking for PhD candidates that are excited to shape the next generation of High-Performance Data Intensive Systems. Learn more <Link
				to="/research/openings">here</Link>.
				</Alert>
				</Panel.Body>
				</Panel>
				<Panel header="Contact"><Panel.Heading>Contact</Panel.Heading>
				<Table>
				<tbody>
				<tr><td>email:</td><td><a href="mailto:hlgr@ic.ac.uk">hlgr@ic.ac.uk</a></td></tr>
				<tr><td>twitter:</td><td><a href="https://mobile.twitter.com/holger_p">holger_p</a></td></tr>
				<tr><td>office:</td><td>Office 431<br/>Huxley Building<br/>Imperial College London</td></tr>
				<tr><td>phone:</td><td>+44 (0)20 7594 3008</td></tr>
				</tbody>
				</Table>
				</Panel>
				</Col>
				<Col xs={12} md={8} mdPull={4}>
				<Panel header="About me"><Panel.Heading>About me</Panel.Heading>
				<Panel.Body>
						I am a Lecturer (roughly assistant professor) in the Department of Computing at Imperial College London. As such, I am a member of the <a href="http://lsds.doc.ic.ac.uk">Large-Scale Data and Systems Group</a>. Before that, I was a Postdoc at the Database group at MIT CSAIL. I spent my PhD years in the Database Architectures group at CWI in Amsterdam resulting in a PhD from the University of Amsterdam in 2015. I received my master's degree (Diplom) in computer science at Humboldt-Universität zu Berlin in 2010. My research interests lie in analytical query processing on memory-resident data. In particular, I study storage schemes and processing models for modern hardware.
</Panel.Body>
				</Panel>
				<Panel header="My Cloud"><Panel.Heading>My Cloud</Panel.Heading>
				<Panel.Body><Image src={cloud} responsive rounded/></Panel.Body>
				</Panel>
</Col>
</Grid>
</div>
)


export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js